/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Divider, Form } from 'antd'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomModal, CustomText, CustomTextInput } from 'src/components'
import {
  saleOffersSelector,
  createSaleOfferGroup,
  resetFilterProjectOfferState,
  resetSalesOfferGroupCreateState,
} from 'src/features'

interface CreateSaleOfferGroupModalProps {
  isModalVisible: boolean
  handleClose: () => void
}

const CreateSaleOfferGroupModal: React.FC<CreateSaleOfferGroupModalProps> = (props) => {
  const { isModalVisible, handleClose } = props
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const [isErrorVisible, setIsErrorVisible] = useState<boolean>(false)
  const { offerGroups: { creatingLoading, successCreate, errorCreate } } = useAppSelector(saleOffersSelector)

  const onFinish = ({ name }: { name: string }) => {
    setIsErrorVisible(false)
    dispatch(createSaleOfferGroup(name))
  }

  useEffect(() => {
    if (successCreate) {
      showNotification('success', t('SalesOffer.GroupCreated'))
      dispatch(resetFilterProjectOfferState())
      handleCancel()
    }
    if (errorCreate) {
      setIsErrorVisible(true)
      dispatch(resetSalesOfferGroupCreateState())
    }
  }, [successCreate, errorCreate])

  const handleCancel = () => {
    form.resetFields()
    handleClose()
    setIsErrorVisible(false)
    dispatch(resetSalesOfferGroupCreateState())
  }

  return (
    <CustomModal
      title={t('SalesOffer.GroupForm')}
      footer={null}
      open={isModalVisible}
      onCancel={() => handleCancel()}
    >
      <Form onFinish={onFinish} form={form}>
        <CustomText label={t('SalesOffer.GroupName')} />
        <CustomTextInput
          required
          name='name'
          placeholder={t('footPrint.FootPrintNamePlaceholder')}
        />
        {isErrorVisible && (
          <div className='blink-animation'>
            <CustomText
              label={t('SalesOffer.GroupError')}
              type='danger'
            />
          </div>
        )}

        <Divider />
        <Button
          block
          size='large'
          type='primary'
          htmlType='submit'
          className='radius-100'
          loading={creatingLoading}
        >
          {creatingLoading ? t('SalesOffer.CreatingGroup') : t('SalesOffer.SubmitGroup')}
        </Button>
      </Form>
    </CustomModal>
  )
}
export default CreateSaleOfferGroupModal
